import axios from 'axios';

import { check, errorHandler } from '../../errors.js';
import { RequestOptions } from '../../types/api-types.js';
import { IPParams, IPResponse } from '../../types/ip-types.js';
import { parseRateLimitingResponse } from '../../utils/api-utils.js';
import SDK_VERSION from '../../utils/sdk-version.js';

export default (
  basePath: string,
  apiKey: string,
  params: IPParams,
  options: RequestOptions = {},
) => new Promise<IPResponse>((resolve, reject) => {
  check(params, basePath, apiKey, null, 'ip').then(() => {
    const headers = {
      'Accept-Encoding': 'gzip',
      'User-Agent': 'PDL-JS-SDK',
      'SDK-Version': SDK_VERSION,
    };

    axios.get<IPResponse>(`${basePath}/ip/enrich`, {
      params: {
        api_key: apiKey,
        ...params,
      },
      headers,
      ...options,
    }).then((response) => {
      if (response?.data?.status === 200) {
        resolve(parseRateLimitingResponse(response));
      }
    }).catch((error) => {
      reject(errorHandler(error));
    });
  }).catch((error) => {
    reject(error);
  });
});
